export const getContextNamespace = (namespace: string) => `${namespace}_context`;
